import SubHeaders from '@/components/Headers/SubHeaders'
import Paper from '@/components/Paper'
import {
    DataTableCustomized,
    FilterBar,
} from '@/components/ui/data-table-customized'
import { paths } from '@/utils/path'
import AddIcons from '@/icons/AddIcons'
import { useRackList } from '../../hooks/use-rack-list'

const RacksList = () => {
    const {
        racks,
        pagination,
        stateComponent,
        control,
        setFilter,
        params,
        searchInputProps,
        columns,
        filterItems,
        filterToggles,
        handleSortChange,
        handlePageChange,
        handlePageSizeChange,
        handleCreate,
    } = useRackList()

    return (
        <>
            <SubHeaders
                breadcrumbs={[
                    {
                        path: paths.warehouse,
                        title: 'Capacities & Resources',
                    },
                    {
                        path: paths.warehouseRacks,
                        title: 'Racks',
                    },
                ]}
                actions={[
                    {
                        icon: <AddIcons />,
                        label: 'New Rack',
                        onClick: handleCreate,
                    },
                ]}
            />

            <Paper className="mt-2 space-y-2">
                <FilterBar
                    storageKey="warehouse-racks"
                    control={control}
                    setFilter={setFilter}
                    items={filterItems}
                />

                {stateComponent || (
                    <DataTableCustomized
                        columns={columns}
                        rows={racks}
                        rowKey={(row) => row.id}
                        size="small"
                        toolbar={{
                            search: {
                                ...searchInputProps,
                                placeholder: 'Search racks...',
                            },
                            settings: {
                                show: true,
                                storageKey: 'warehouse-racks',
                                filterToggles,
                            },
                        }}
                        sorting={{
                            sortBy: params.sort_by,
                            sortOrder: params.sort_order,
                            onSortChange: handleSortChange,
                        }}
                        pagination={{
                            page: params.page,
                            pageSize: params.page_size,
                            total: pagination?.total || 0,
                            onPageChange: handlePageChange,
                            onPageSizeChange: handlePageSizeChange,
                        }}
                    />
                )}
            </Paper>
        </>
    )
}

export default RacksList

// Barrel exports for Racks module
export { default as RackDetail } from './RackDetail'
export { tabs as rackTabs } from './tabs'
